import { render } from "./MoatInitiative.vue?vue&type=template&id=9d93e476"
import script from "./MoatInitiative.vue?vue&type=script&lang=js"
export * from "./MoatInitiative.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__